import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { BudgetAsideHeader } from './BudgetAsideHeader';

import { NoticeChip } from '@/components/ui';

/**
 * The budget rail before the project has a contract: the panel's header and a
 * nudge, nothing else.
 *
 * It exists because `ProjectBudgetAside` cannot render here — it reads
 * `useFinancials()`, and that provider needs a contract — while the rail itself
 * should still be *there*, collapsed to its chevron, the way Planning's is. On
 * this page the drawer lands collapsed (`Panels defaultCollapsed`), so this
 * content is what a user finds when they deliberately open it.
 *
 * Help text only (2026-10-01, the pilot's ask): its "Add contract" link went,
 * leaving the empty card's button as the page's one call to action.
 */

export type ProjectBudgetAsideEmptyProps = {
  projectName: string;
  projectCode?: string;
  customerName?: string;
};

export const ProjectBudgetAsideEmpty = ({
  projectName,
  projectCode,
  customerName,
}: ProjectBudgetAsideEmptyProps) => {
  const { t } = useTranslation('pmFinancials');
  return (
    <Box data-automation-id="budget-aside-empty">
      <BudgetAsideHeader
        projectName={projectName}
        projectCode={projectCode}
        customerName={customerName}
      />

      {/*
      `mt: 2` under the header, as the Team and Billing rails' note. An info
      NoticeChip, not the warning amber of `trapped-amount-notice`: nothing is
      wrong here, and amber in a budget panel reads as a problem to fix.
    */}
      <Box sx={{ mt: 2 }}>
        <NoticeChip tone="info" icon="info" automationId="no-contract-nudge">
          {t('budgetAside.EmptyNudge')}
        </NoticeChip>
      </Box>
    </Box>
  );
};
